import { Component, OnInit ,Input} from '@angular/core';
import { ProceduresService } from '../procedures.service';
import { HelperService } from '../../core/helper';
import { FlashMessageWrapperService } from '../../../app/shared/services/flash-message-wrapper.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-assignchildprocedure-screen',
  templateUrl: './assignchildprocedure.screen.component.html',
  // styleUrls: ['./assignchildprocedure.screen.component.scss'],
  providers: [
    ProceduresService,
    HelperService
  ],
  standalone: false
})
export class AssignChildProcedureScreenComponent implements OnInit {

  @Input() procedure: any;
  parentProcedureName = '';
  proceduresList: Array<any> = [];
  selectedAssignChildProcedure: string = null;
  ProcedureValidationList: any = {
		proceduresList: '',
	}

  constructor(
    private _proceduresService: ProceduresService,
    private _helper: HelperService,
    private _flashMessagesService: FlashMessageWrapperService,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,

  ) { }

  ngOnInit(): void {
    this.parentProcedureName = this.procedure.procedureName;
    console.log("parentProcedureName", this.parentProcedureName)
    this.getProceduresList();
  }

  getProceduresList() {
    this._proceduresService.getProceduresList(false).subscribe(
      (proceduresData) => {
        console.log("proceduresData-=-=",proceduresData)
        this.proceduresList = proceduresData.data.procedureData.filter(
          x => x.id !== this.procedure.id && (!x.ChildMappings || x.ChildMappings.length === 0));
      },
      error => console.log(error)

    );

  }

  closePopup() {
    this.activeModal.close();
  }

  saveChildProcedure() {
    const isChildProcedureValid = this.performValidation();
    if (isChildProcedureValid) {
			const params = {
				'childprocedureId': this.selectedAssignChildProcedure,
				'parentprocedureId': this.procedure.id
			};
      
      console.log("params :[]", params);
      this._proceduresService.assignChildProcedure(params).subscribe((procedureData) => {
				if (procedureData.status === 'success') {
          console.log("procedureData", procedureData)
					this._flashMessagesService.show(procedureData.message, { cssClass: 'alert-success', timeout: 4000 });
				} else {
					this._flashMessagesService.show('Something went wrong!', { cssClass: 'alert-danger', timeout: 4000 });
				}
				this.spinner.hide();
				this.activeModal.close({});
			},
				(error) => {
					this.spinner.hide();
					this.activeModal.close({});
				}
			)

    }

  }


  performValidation() {
		let isChildProcedureValid = true;
		this.ProcedureValidationList = { proceduresList: '' };
		if (this.selectedAssignChildProcedure === null) {
			isChildProcedureValid = false;
			this.ProcedureValidationList.proceduresList = 'This field is required!';
		}
		return isChildProcedureValid;
	}

}